if not App.angularApp?
    return

App.angularApp.directive 'mfFocusMe', ['$timeout', ($timeout) ->
    return {
        link: (scope, element, attrs) ->

            scope.$watch attrs.mfFocusMe, (value) =>
                $timeout () =>
                    element[0].focus()

    }
]
